declare global {
  interface Window {
    env: any;
  }
}

type EnvType = {
  REACT_APP_BUILD_VERSION: string;
  REACT_APP_MATOMO_HOME: string;
  REACT_APP_MATOMO_SITE_ID: string;
  REACT_APP_ENABLE_DISPLAY_TRANSLATION_KEYS: string;
  REACT_APP_BFF_URL: string;
  REACT_APP_BFF_USER_BEHAVIOUR_URL: string;
  REACT_APP_ENVIRONMENT: string;
  REACT_APP_DEALER_LOCATOR_URLS: string;
};

export const env: EnvType = { ...process.env, ...window.env };

export const isLocalEnvironment = (): boolean => env.REACT_APP_ENVIRONMENT === 'local';

export const dealerLocatorUrls: Record<string, string> = (() => {
  try {
    return JSON.parse(env.REACT_APP_DEALER_LOCATOR_URLS || '{}');
  } catch {
    return {};
  }
})();
